export default "Click the button and you might win!";